import { Component, OnInit } from "@angular/core";
import { CatTipoIngresoService } from "../../servicios/cat-tipo-ingreso.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatTipoIngreso } from "../../entidades/entidades";
@Component({
  selector: "app-cat-tipo-ingreso-grid",
  templateUrl: "./cat-tipo-ingreso-grid.component.html",
  styleUrls: ["./cat-tipo-ingreso-grid.component.css"],
})
export class CatTipoIngresoGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catTipoIngreso: CatTipoIngreso[];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedCatTipoIngreso: { [s: string]: CatTipoIngreso } = {};

  constructor(
   private catTipoIngresoService: CatTipoIngresoService,
  ) {}

  ngOnInit(): void {
    this.getAllCatTipoIngreso();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), },
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridCatTipoIngreso();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllCatTipoIngreso();} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "Editar", ordenar: false, styleHeader: "width: 30px;"},
/*       {field: "id", header: "Id",ordenar: false, styleHeader: "width: 30px;",}, */
      {field: "descripcion", header: "Descripcion",ordenar: true, styleHeader: "width: 150px;",},
     // {field: "acciones", header: "Eliminar",ordenar: false, styleHeader: "width: 30px;",},
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let catTipoIngresoNew = new CatTipoIngreso();
    catTipoIngresoNew.cambio = true;
    catTipoIngresoNew.id = 0;
    catTipoIngresoNew.numRow = this.catTipoIngreso.length + 1;
    this.catTipoIngreso.unshift(catTipoIngresoNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let catTipoIngresoEdit = event.data;
    this.clonedCatTipoIngreso[catTipoIngresoEdit.numRow] = { ...catTipoIngresoEdit };
    catTipoIngresoEdit.cambio = true;
    catTipoIngresoEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let catTipoIngresoEdit = event.data;
    let index = this.catTipoIngreso.findIndex(
      (obj) => obj.numRow === catTipoIngresoEdit.numRow
    );
    this.catTipoIngreso[index] = { ...this.clonedCatTipoIngreso[catTipoIngresoEdit.numRow]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let catTipoIngresoEdit = event.data;

      //Valida si hay cambios
      if (
        catTipoIngresoEdit.id === this.clonedCatTipoIngreso[catTipoIngresoEdit.numRow].id &&
        catTipoIngresoEdit.descripcion === this.clonedCatTipoIngreso[catTipoIngresoEdit.numRow].descripcion 
      ) {
        let index = this.catTipoIngreso.findIndex((obj) => obj.numRow === catTipoIngresoEdit.numRow);
        this.catTipoIngreso[index] = {...this.clonedCatTipoIngreso[catTipoIngresoEdit.numRow]};
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      catTipoIngresoEdit.cambio = true;
      catTipoIngresoEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridCatTipoIngreso() {
    try {
      for (let catTipoIngresoFor of this.catTipoIngreso) {
        if (catTipoIngresoFor.baja) {
          await this.deleteCatTipoIngreso(catTipoIngresoFor);
        } else if (catTipoIngresoFor.cambio) {
          catTipoIngresoFor.cambio = false;
          this.clonedCatTipoIngreso[catTipoIngresoFor.id] = { ...catTipoIngresoFor, };
          if (catTipoIngresoFor.id === 0) {
            const datoRetorno = await this.addCatTipoIngreso(catTipoIngresoFor);
            catTipoIngresoFor.id = datoRetorno.id;
          } else {
            await this.updateCatTipoIngreso(catTipoIngresoFor);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatTipoIngreso");
    }
  }

  // prettier-ignore
  async addCatTipoIngreso(catTipoIngreso) {
    try {
      const datoretorno = await this.catTipoIngresoService
        .add(catTipoIngreso)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatTipoIngreso");
    }
  }

  // prettier-ignore
  async getAllCatTipoIngreso() {
    try {
      const datoRetorno = await this.catTipoIngresoService.getAll().toPromise();
      this.catTipoIngreso = datoRetorno;
      for (var i = 0, len = this.catTipoIngreso.length; i < len; ++i){
        this.catTipoIngreso[i].numRow = i;
        this.clonedCatTipoIngreso[this.catTipoIngreso[i].numRow] = {...this.catTipoIngreso[i],        };
      } 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatTipoIngreso");
    }
  }

  // prettier-ignore
  async updateCatTipoIngreso(catTipoIngreso: CatTipoIngreso) {
    try {
      const datoRetorno = await this.catTipoIngresoService
        .update(catTipoIngreso)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatTipoIngreso");
    }
  }

  // prettier-ignore
  async deleteCatTipoIngreso(catTipoIngreso: CatTipoIngreso) {
    try {
      const datoRetorno = await this.catTipoIngresoService
        .delete(catTipoIngreso.id)
        .toPromise();
      this.getAllCatTipoIngreso();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatTipoIngreso");
    }
  }
}